import $ from 'jquery';
import Select2BaseColumn from './Select2BaseColumn';
import {odata, localize} from 'linksoft';
const Resx = localize('Common');

export default class BooleanColumn extends Select2BaseColumn {

	displayValue(value) {
		return value
			? Resx.Common.Yes
			: Resx.Common.No;
	}

	createEditor(value, id) {
		const inputId = this.column.name() + '_' + id;
		return (
`<span class="checkbox">
	<input id="${inputId}" class="table-input" type="checkbox" ${value ? 'checked' : ''} />
	<label for="${inputId}"></label>
</span>`);
	}

	getEditorValue(cellElement) {
		return $(cellElement).find('input.table-input').is(':checked');
	}


	// -------------- FILTERS --------------------

	createFilter() {
		return `<div class="input-group">
    <select class="form-control table-filter">
        <option value="">${Resx.Common.All}</option>
        <option value="true">${Resx.Common.Yes}</option>
        <option value="false">${Resx.Common.No}</option>
    </select>
</div>`;
	}

	buildFilterExpression(fieldName, columnFilter) {
		if (columnFilter === 'true' || columnFilter === 'false') {
			return odata.filters.equals(fieldName, columnFilter === 'true');
		} else {
			return null;
		}
	}
}


// WEBPACK FOOTER //
// ./node_modules/linksoft-datatables/src/renderers/BooleanColumn.js